import { WorkspacePostingOpportunitiesPort } from '../ports'
import WorkspacePostingOpportunityStore from './WorkspacePostingOpportunityStore'
import { ListWorkspacePostingOpportunitiesQuery } from './dtos/queries'
import { CursorPaged } from '../../types/definitions'
import WorkspacePostingOpportunity from './WorkspacePostingOpportunity'

export default class WorkspaceOpportunitiesAdapter
  implements WorkspacePostingOpportunitiesPort
{
  constructor(
    private workspacePostingOpportunityStore: WorkspacePostingOpportunityStore,
  ) {}

  async query(
    query: ListWorkspacePostingOpportunitiesQuery,
  ): Promise<CursorPaged<WorkspacePostingOpportunity>> {
    return this.workspacePostingOpportunityStore.listOpportunities(query)
  }

  async applyToOpportunity(opportunityId: string): Promise<void> {
    return this.workspacePostingOpportunityStore.applyToOpportunity(
      opportunityId,
    )
  }

  async withdrawFromOpportunity(opportunityId: string): Promise<void> {
    return this.workspacePostingOpportunityStore.withdrawFromOpportunity(
      opportunityId,
    )
  }

  async canViewWorkspaceOpportunities(): Promise<boolean> {
    return this.workspacePostingOpportunityStore.canViewWorkspaceOpportunities()
  }
}
